// Mock user data for the Caribbean LGBTQ+ travel platform
const mockUsers = [
  {
    id: 1,
    username: "mariasanchez",
    password: "password123", // In a real app, passwords would be hashed and not stored in plain text
    name: "Maria Sanchez",
    pronouns: "She/her",
    genderIdentity: ["woman", "trans woman"],
    sexualOrientation: "lesbian",
    bio: "Travel enthusiast and photographer based in San Juan. I love exploring hidden beaches and local cuisine.",
    avatar: "https://randomuser.me/api/portraits/women/65.jpg",
    location: "San Juan, Puerto Rico",
    isLocalQueer: true,
    travelStyle: ["beach", "food", "photography", "culture"],
    favoriteDestinations: ["Curaçao", "St. Lucia", "Barbados"],
    languages: ["English", "Spanish"],
    accessibilityNeeds: ["mobility-friendly"],
    socialLinks: {
      instagram: "@mariasancheztravel",
      twitter: "@mariasanchez",
      website: "https://mariasanchez.com"
    },
    visibilitySettings: {
      pronouns: "public",
      genderIdentity: "community",
      sexualOrientation: "community",
      location: "public"
    },
    anonymousMode: false,
    joinDate: "2023-05-15",
    lastActive: "2025-06-12"
  },
  {
    id: 2,
    username: "davidchen",
    password: "password123",
    name: "David Chen",
    pronouns: "He/him",
    genderIdentity: ["man", "cis man"],
    sexualOrientation: "gay",
    bio: "Digital nomad working remotely while exploring the Caribbean islands. Always looking for LGBTQ+ friendly accommodations.",
    avatar: "https://randomuser.me/api/portraits/men/22.jpg",
    location: "Miami, Florida",
    isLocalQueer: false,
    travelStyle: ["luxury", "digital nomad", "adventure", "nightlife"],
    favoriteDestinations: ["Aruba", "Jamaica", "Dominican Republic"],
    languages: ["English", "Mandarin"],
    accessibilityNeeds: [],
    socialLinks: {
      instagram: "@davidchentravel",
      linkedin: "davidchen"
    },
    visibilitySettings: {
      pronouns: "public",
      genderIdentity: "public",
      sexualOrientation: "public",
      location: "community"
    },
    anonymousMode: false,
    joinDate: "2024-01-10",
    lastActive: "2025-06-13"
  },
  {
    id: 3,
    username: "sophiewilliams",
    password: "password123",
    name: "Sophie Williams",
    pronouns: "They/them",
    genderIdentity: ["non-binary"],
    sexualOrientation: "pansexual",
    bio: "Marine biologist and diving instructor. I can help you discover the best diving spots in Bonaire!",
    avatar: "https://randomuser.me/api/portraits/women/33.jpg",
    location: "Kralendijk, Bonaire",
    isLocalQueer: true,
    travelStyle: ["eco-tourism", "diving", "nature", "adventure"],
    favoriteDestinations: ["Bonaire", "Curaçao", "St. Croix"],
    languages: ["English", "Dutch", "Papiamento"],
    accessibilityNeeds: [],
    socialLinks: {
      instagram: "@sophiedives",
      facebook: "sophiewilliamsdiving"
    },
    visibilitySettings: {
      pronouns: "public",
      genderIdentity: "public",
      sexualOrientation: "community",
      location: "public"
    },
    anonymousMode: false,
    joinDate: "2023-08-22",
    lastActive: "2025-06-10"
  },
  {
    id: 4,
    username: "alexrivera",
    password: "password123",
    name: "Alex Rivera",
    pronouns: "He/him",
    genderIdentity: ["man", "cis man"],
    sexualOrientation: "bisexual",
    bio: "Local tour guide specializing in LGBTQ+ friendly experiences in Trinidad. Ask me about the best carnival events!",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    location: "Port of Spain, Trinidad",
    isLocalQueer: true,
    travelStyle: ["cultural", "festivals", "nightlife", "history"],
    favoriteDestinations: ["Trinidad", "Barbados", "St. Lucia"],
    languages: ["English", "Spanish"],
    accessibilityNeeds: [],
    socialLinks: {
      instagram: "@alexriveratours",
      twitter: "@alexrivera"
    },
    visibilitySettings: {
      pronouns: "public",
      genderIdentity: "community",
      sexualOrientation: "community",
      location: "public"
    },
    anonymousMode: false,
    joinDate: "2024-02-15",
    lastActive: "2025-06-14"
  },
  {
    id: 5,
    username: "jasmineking",
    password: "password123",
    name: "Jasmine King",
    pronouns: "She/her",
    genderIdentity: ["woman", "cis woman"],
    sexualOrientation: "questioning",
    bio: "First-time solo traveler looking to connect with other LGBTQ+ travelers in the Caribbean.",
    avatar: "https://randomuser.me/api/portraits/women/45.jpg",
    location: "Toronto, Canada",
    isLocalQueer: false,
    travelStyle: ["solo", "budget", "beach", "relaxation"],
    favoriteDestinations: ["Cuba", "Dominican Republic"],
    languages: ["English", "French"],
    accessibilityNeeds: [],
    socialLinks: {
      instagram: "@jasminekingtravel"
    },
    visibilitySettings: {
      pronouns: "public",
      genderIdentity: "private",
      sexualOrientation: "private",
      location: "community"
    },
    anonymousMode: true,
    joinDate: "2025-01-05",
    lastActive: "2025-06-11"
  },
  {
    id: 6,
    username: "marcusjohnson",
    password: "password123",
    name: "Marcus Johnson",
    pronouns: "He/him",
    genderIdentity: ["man", "trans man"],
    sexualOrientation: "gay",
    bio: "Photographer and travel blogger documenting LGBTQ+ friendly spaces across the Caribbean.",
    avatar: "https://randomuser.me/api/portraits/men/55.jpg",
    location: "Kingston, Jamaica",
    isLocalQueer: true,
    travelStyle: ["photography", "blogging", "cultural", "food"],
    favoriteDestinations: ["Jamaica", "Bahamas", "Cayman Islands"],
    languages: ["English", "Jamaican Patois"],
    accessibilityNeeds: [],
    socialLinks: {
      instagram: "@marcusjphoto",
      website: "https://marcusjohnsonphotography.com"
    },
    visibilitySettings: {
      pronouns: "public",
      genderIdentity: "community",
      sexualOrientation: "community",
      location: "public"
    },
    anonymousMode: false,
    joinDate: "2023-11-20",
    lastActive: "2025-06-13"
  },
  {
    id: 7,
    username: "elenarodriguez",
    password: "password123",
    name: "Elena Rodriguez",
    pronouns: "She/her",
    genderIdentity: ["woman", "cis woman"],
    sexualOrientation: "lesbian",
    bio: "Restaurant owner in Havana. I can recommend the best LGBTQ+ friendly dining spots across Cuba!",
    avatar: "https://randomuser.me/api/portraits/women/28.jpg",
    location: "Havana, Cuba",
    isLocalQueer: true,
    travelStyle: ["food", "culture", "music", "history"],
    favoriteDestinations: ["Cuba", "Puerto Rico", "Dominican Republic"],
    languages: ["Spanish", "English"],
    accessibilityNeeds: [],
    socialLinks: {
      instagram: "@elenascuisine",
      facebook: "elenasrestaurant"
    },
    visibilitySettings: {
      pronouns: "public",
      genderIdentity: "public",
      sexualOrientation: "public",
      location: "public"
    },
    anonymousMode: false,
    joinDate: "2024-03-10",
    lastActive: "2025-06-12"
  },
  {
    id: 8,
    username: "samliu",
    password: "password123",
    name: "Sam Liu",
    pronouns: "They/them",
    genderIdentity: ["non-binary", "genderfluid"],
    sexualOrientation: "pansexual",
    bio: "Artist and digital nomad currently island-hopping through the Caribbean. Looking for creative inspiration and community connections.",
    avatar: "https://randomuser.me/api/portraits/lego/1.jpg",
    location: "Traveling",
    isLocalQueer: false,
    travelStyle: ["digital nomad", "art", "culture", "budget"],
    favoriteDestinations: ["St. Martin", "Guadeloupe", "Martinique"],
    languages: ["English", "Mandarin", "French"],
    accessibilityNeeds: ["neurodivergent-friendly"],
    socialLinks: {
      instagram: "@samliuart",
      website: "https://samliu.art"
    },
    visibilitySettings: {
      pronouns: "public",
      genderIdentity: "community",
      sexualOrientation: "community",
      location: "community"
    },
    anonymousMode: false,
    joinDate: "2024-05-01",
    lastActive: "2025-06-14"
  },
  {
    id: 9,
    username: "oliviasmith",
    password: "password123",
    name: "Olivia Smith",
    pronouns: "She/her",
    genderIdentity: ["woman", "cis woman"],
    sexualOrientation: "bisexual",
    bio: "Travel agent specializing in LGBTQ+ friendly Caribbean vacations. Let me help you plan your perfect trip!",
    avatar: "https://randomuser.me/api/portraits/women/17.jpg",
    location: "Nassau, Bahamas",
    isLocalQueer: true,
    travelStyle: ["luxury", "romance", "relaxation", "adventure"],
    favoriteDestinations: ["Bahamas", "Turks and Caicos", "St. Barts"],
    languages: ["English"],
    accessibilityNeeds: [],
    socialLinks: {
      instagram: "@oliviastravels",
      linkedin: "oliviasmithtravel",
      website: "https://rainbowcaribbeantravel.com"
    },
    visibilitySettings: {
      pronouns: "public",
      genderIdentity: "public",
      sexualOrientation: "public",
      location: "public"
    },
    anonymousMode: false,
    joinDate: "2023-09-15",
    lastActive: "2025-06-13"
  },
  {
    id: 10,
    username: "jameswalker",
    password: "password123",
    name: "James Walker",
    pronouns: "He/him",
    genderIdentity: ["man", "cis man"],
    sexualOrientation: "gay",
    bio: "Sailing enthusiast exploring the Caribbean by boat. Looking for crew members and travel companions!",
    avatar: "https://randomuser.me/api/portraits/men/78.jpg",
    location: "St. Thomas, USVI",
    isLocalQueer: false,
    travelStyle: ["sailing", "adventure", "island-hopping", "water sports"],
    favoriteDestinations: ["US Virgin Islands", "British Virgin Islands", "Antigua"],
    languages: ["English"],
    accessibilityNeeds: [],
    socialLinks: {
      instagram: "@jamesonthesea",
      youtube: "SailingWithJames"
    },
    visibilitySettings: {
      pronouns: "public",
      genderIdentity: "community",
      sexualOrientation: "community",
      location: "public"
    },
    anonymousMode: false,
    joinDate: "2024-04-20",
    lastActive: "2025-06-10"
  }
];

export default mockUsers;
